import React from 'react';
import { OutboundLink } from 'gatsby-plugin-google-analytics';

function Advertisers() {
  const Advertisers = [
    {
      id: '01',
      image: '/dvmf-2022/ads/biomerieux.jpg',
      link: 'https://careers.biomerieux.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=deervalleymusicfestival',
      alt: 'Biomerieux',
      class: 'webFormat',
    },
    {
      id: '02',
      image: '/dvmf-2022/ads/bmw-murray.jpg',
      link: 'https://bmwutah.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=deervalleymusicfestival',
      alt: 'BMW of Murray',
      class: 'webFormat',
    },
    {
      id: '03',
      image: '/dvmf-2022/ads/grand-teton.jpg',
      link: 'https://gtmf.org/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=deervalleymusicfestival',
      alt: 'Grand Teton Music Festival',
      class: 'webFormat',
    },
    {
      id: '04',
      image: '/dvmf-2022/ads/mercedes-slc.jpg',
      link: 'https://kengarffmercedes.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=deervalleymusicfestival',
      alt: 'Mercedes-Benz of Salt Lake City',
      class: 'webFormat',
    },
    {
      id: '05',
      image: '/dvmf-2022/ads/moab-music-fest.jpg',
      link: 'https://moabmusicfest.org/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=deervalleymusicfestival',
      alt: 'Moab Music Festival',
      class: 'webFormat',
    },
    {
      id: '06',
      image: '/dvmf-2022/ads/nature-conservancy.jpg',
      link: 'https://nature.org/utah/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=deervalleymusicfestival',
      alt: 'The Nature Conservancy of Utah',
      class: 'webFormat',
    },
    {
      id: '07',
      image: '/dvmf-2022/ads/oc-tanner.jpg',
      link: 'https://octannerjewelers.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=deervalleymusicfestival',
      alt: 'OC Tanner Jewelers',
      class: 'webFormat',
    },
    {
      id: '08',
      image: '/dvmf-2022/ads/red-ledges.jpg',
      link: 'https://redledges.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=deervalleymusicfestival',
      alt: 'Red Ledges Utah',
      class: 'webFormat',
    },
    {
      id: '09',
      image: '/dvmf-2022/ads/regency-royal.jpg',
      link: 'https://regencyroyale.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=deervalleymusicfestival',
      alt: 'Regency Royale',
      class: 'webFormat',
    },
    {
      id: '10',
      image: '/dvmf-2022/ads/thomas-jacobson.jpg',
      link: 'http://www.tomjacobsonlaw.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=deervalleymusicfestival',
      alt: 'Thomas Jacobson',
      class: 'webFormat',
    },
    {
      id: '11',
      image: '/dvmf-2022/ads/tuacahn.jpg',
      link: 'https://www.tuacahn.org/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=deervalleymusicfestival',
      alt: 'Tuacahn',
      class: 'webFormat',
    },
    {
      id: '12',
      image: '/dvmf-2022/ads/ufo.jpg',
      link: 'https://www.utahfestival.org/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=deervalleymusicfestival',
      alt: 'Utah Festival Opera',
      class: 'webFormat',
    },
    {
      id: '13',
      image: '/dvmf-2022/ads/challenger.jpg',
      link: 'https://www.challengerschool.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=deervalleymusicfestival',
      alt: 'Challenger School',
      class: 'webFormat',
    },
    {
      id: '14',
      image: '/dvmf-2022/ads/explore-logan.jpg',
      link: 'https://www.explorelogan.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=deervalleymusicfestival',
      alt: 'Explore Logan',
      class: 'webFormat',
    },
    {
      id: '15',
      image: '/dvmf-2022/ads/hamilton-park.jpg',
      link: 'https://hamiltonparkinteriors.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=deervalleymusicfestival',
      alt: 'Hamilton Park Interiors',
      class: 'webFormat',
    },
    {
      id: '16',
      image: '/dvmf-2022/ads/rc-willey.jpg',
      link: 'https://www.rcwilley.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=deervalleymusicfestival',
      alt: 'RC Willey',
      class: 'webFormat',
    },
    {
      id: '17',
      image: '/dvmf-2022/ads/click-it.jpg',
      link: 'https://clickit.utah.gov/buckleup/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=deervalleymusicfestival',
      alt: 'University of Utah Credit Union',
      class: 'webFormat',
    },
    {
      id: '18',
      image: '/dvmf-2022/ads/rubys-inn.jpg',
      link: 'https://rubysinn.com/summerarts22',
      alt: 'Rubys Inn',
      class: 'webFormat',
    },
    {
      id: '19',
      image: '/dvmf-2022/ads/u-first.jpg',
      link: 'https://www.ufirstcu.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=deervalleymusicfestival',
      alt: 'UFirst Credit Union',
      class: 'webFormat',
    },
    {
      id: '20',
      image: '/dvmf-2022/ads/aladdin.jpg',
      link: 'https://www.aladdinskylights.com/?utm_source=Mills%20Publishing&utm_medium=Digital%20playbill&utm_campaign=deervalleymusicfestival',
      alt: 'Aladdin Skylights',
      class: 'webFormat',
    },
  ];

  Advertisers.sort((a, b) => a.alt.localeCompare(b.alt));

  return (
    <div>
      {Advertisers.map((data) => (
        <details key={data.id}>
          <summary>{data.alt}</summary>
          <OutboundLink
            href={data.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={data.image} alt={data.alt} className={data.class} />
          </OutboundLink>
        </details>
      ))}
    </div>
  );
}

export default Advertisers;
